import Quill from 'quill'

let Embed = Quill.import('blots/embed')
// import VariableHelpers from '@/assets/js/variableHelpers.js'
import EventBus from '@/assets/js/eventBus.js'
import Store from '@/store/store.js'

// a simple blot to represent an editor synonym.
class SynonymBlot extends Embed {
	static create(synonym) {
        let node = super.create()
		let sliceEnd = synonym.values.indexOf('|')
		if(sliceEnd == -1) sliceEnd = synonym.values.length
        // node.innerText = synonym.values.slice(0, sliceEnd)
        // node.innerText = '·'+synonym.values.slice(0, sliceEnd)
        node.innerText = synonym.values.slice(0, sliceEnd)
        node.setAttribute('title', synonym.values)
		node.setAttribute('value',  synonym.values)
		node.classList.add('synonym-blot')
		node.addEventListener('click', event => {
			// Store.dispatch('synonymClicked', { node, synonym, event })
			EventBus.$emit('synonymClicked', { node, synonym, event })
        })
        // console.log(node)
		return node
	}

		//Goes to delta.attributes
		static formats(node) {
			return {
				values: node.getAttribute('value'),
			}
		}
		
		//Goes to delta.insert
		static value(node) {
			return {
				values: node.getAttribute('value'),
			
		}
	}
	// static formats(node) {
	// 	return {
	// 		name: ':syn(' +node.getAttribute('value') + ')',
	// 		displayName: node.innerText,
	// 		formatting:  node.getAttribute('formatting')
	// 	}
	// }

	// static value(node) {
	// 	return {
	// 		name: ':syn(' +node.getAttribute('value') + ')',
	// 		displayName: node.innerText,
	// 		formatting:  node.getAttribute('formatting')
	// 	}
	// }
}

SynonymBlot.blotName = 'synonym'
SynonymBlot.tagName = 'span'
SynonymBlot.className = 'synonym-blot-class'

export default SynonymBlot
// Quill.register(SynonymBlot, true)
